import global from './Globals';

const Loader = {
  loaderSpin: global.primary400,
  loaderSpinBg: 'rgba(0, 0, 0, 0.1) ',
  loaderTextColour: global.black,
};

export default Loader;
